import React from "react";
import Child from "./Child";
import { motion } from "framer-motion";
import classNames from "../../utils/classNames";
import { item } from "../../utils/animationUtils";

const defaultIcon = "bi bi-journal-text";
const defaultProps = {
  onClick: () => {},
};

function Item({ menu, onClick }) {
  const { name, icon, label, disabled } = menu;
  const route = menu.route || "/" + name;
  if (Array.isArray(route)) {
    return <Child menu={menu} onClick={onClick} />;
  }
  return (
    <motion.li variants={item} className="nav-item" key={route}>
      <a
        onClick={(e) => onClick(e, menu)}
        href={route}
        className={classNames(
          "nav-link text-truncate",
          disabled ? "disabled" : ""
        )}
        to={route}
      >
        <i className={`${icon || defaultIcon} text-secondary`}></i>
        <span className="ms-2 text-primary fw-medium">{label || name}</span>
      </a>
    </motion.li>
  );
}

Item.defaultProps = defaultProps;
export default Item;
